import { GroupsCheckboxConfigService } from './shared/groups-checkbox.config.service';
import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { SubForma, BaseControl, ConfirmComponent } from '@app/shared';
import { LocalDataSource } from 'ng2-smart-table';
import { GroupsCheckboxFormService } from './shared/groups-checkbox.form.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-groups-checkbox',
  templateUrl: './groups-checkbox.component.html',
  styleUrls: ['./groups-checkbox.component.scss'],
  providers: [GroupsCheckboxFormService]
})
export class GroupsCheckboxComponent implements OnInit, OnDestroy {

  @Input() form: SubForma;
  // Cadena de accion a realizar
  actionForm = 'Agregar';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Index de el grupo seleccionado para modificar
  indexRowSelect = -1;
  // Define cuando mostrar el formulario de agregar
  openFormGroups = false;
  // Define cuando se actualiza un grupo
  updateGroup = false;
  // Contiene los controles del formulario para agregar los campos
  controls: BaseControl<any>[] = [];
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Configuracion de la tabla
  settings = {};
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;

  constructor(
    private gcfs: GroupsCheckboxFormService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    if (this.form) {
      if (!this.form.estilo['groupCheckbox']) {
        if (Object.keys(this.form.estilo).length) {
          this.form.estilo['groupCheckbox'] = [];
        } else {
          this.form.estilo = {
            groupCheckbox: [],
          };
        }
      }
      this.loadingGroupsCheck();
    }
    const configTable = new GroupsCheckboxConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((data: any) => {
      this.accionTable(data.action, data.data);
    });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Controla las acciones realizadas en la tabla
   *
   * @param {('update' | 'delete')} action
   * @param {*} [data]
   * @memberof GroupsCheckboxComponent
   */
  accionTable(action: 'update' | 'delete', data?: any) {
    switch (action) {
      case 'update':
        this.openForm(data);
        break;
      case 'delete':
        if (data && data.index >= 0) {
          this.indexRowSelect = data.index;
          this.updateGroup = false;
          this.question = '¿Realmente desea eliminar el grupo?';
          this.confirm.open();
        }
        break;
    }
  }

  /**
   * Abre el formulario de agregar o editar el grupo de checkbox
   *
   * @param {*} [data]
   * @memberof GroupsCheckboxComponent
   */
  openForm(data?: any) {
    if (data) {
      this.updateGroup = true;
      this.actionForm = 'Modificar';
      this.indexRowSelect = data.index;
    } else {
      this.updateGroup = false;
      this.actionForm = 'Agregar';
      this.indexRowSelect = -1;
    }
    this.controls = this.gcfs.getFormGroupCheckbox(data);
    this.openFormGroups = true;
  }

  /**
   * Cierra el formulario de agregar o editar el grupo de checkbox
   *
   * @memberof GroupsCheckboxComponent
   */
  close() {
    this.openFormGroups = false;
    this.controls = [];
    this.updateGroup = false;
    this.indexRowSelect = -1;
  }

  /**
   * Guarda el formulario de agregar o editar el grupo de checkbox
   *
   * @param {*} data
   * @memberof GroupsCheckboxComponent
   */
  save(data: any) {
    let valid = true;
    if (Number(data.numMinimo) >= 0 && Number(data.numMaximo) > 0) {
      if (Number(data.numMinimo) > Number(data.numMaximo)) {
        valid = false;
        this.toastr.warning(
          'El número máximo de selección de cajas no puede ser menor al número mínimo',
          'Información inválida'
        );
      }
    }
    if (valid) {
      const newGroup = {
        nombre: data.txtNombreGrupo,
        min: data.numMinimo,
        max: data.numMaximo,
        mensajeMin: data.txtMensajeMinimo ? data.txtMensajeMinimo : '',
        mensajeMax: data.txtMensajeMaximo ? data.txtMensajeMaximo : '',
      };
      if (!this.updateGroup) {
        this.form.estilo['groupCheckbox'].push(newGroup);
      } else {
        this.form.estilo['groupCheckbox'][this.indexRowSelect] = newGroup;
      }
      this.loadingGroupsCheck();
      this.close();
    }
  }

  /**
   * Elimina el gruppo seleccionado
   *
   * @memberof GroupsCheckboxComponent
   */
  removeGroup() {
    if (this.indexRowSelect !== -1) {
      this.form.estilo['groupCheckbox'].splice(this.indexRowSelect, 1);
      this.loadingGroupsCheck();
    }
  }

  /**
   * Controla las confirmaciones del componente
   *
   * @param {boolean} res
   * @memberof GroupsCheckboxComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.removeGroup();
    }
    this.question = '';
  }

  /**
   * Carga los grupos en la tabla
   *
   * @private
   * @memberof GroupsCheckboxComponent
   */
  private loadingGroupsCheck() {
    if (this.form) {
      if (this.form.estilo['groupCheckbox'] && this.form.estilo['groupCheckbox'].length) {
        this.form.estilo['groupCheckbox'].forEach((group: any, index: number) => {
          group['index'] = index;
        });
      }
      this.sourceData = new LocalDataSource(this.form.estilo['groupCheckbox']);
      this.sourceData.refresh();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/groups-checkbox/groups-checkbox.component.ts